export default class {
    // @ngInject
    constructor(responseHandler, authService) {
        this.responseHandler = responseHandler;
        this.authService = authService;
        this.success = false;
        this.data = {email: undefined};
    }

    submit() {
        let promise = this.authService.resendActivationEmail(this.data);
        this.responseHandler(promise, 'resending your activation email')
            .then(() => this.success = true);
    }
}



// WEBPACK FOOTER //
// ./activate/resend/resend-ctrl.js